import React from 'react'

import { SelectCP } from 'common/components/form-fields/select/SelectCP'
import { SelectOptionTP } from 'common/components/form-fields/select/inner/types/SelectOptionTP'
import { IFormItemCommonProps } from 'common/components/form-fields/inner/interfaces/IFormItemCommonProps'
import { GenderEnum } from 'modules/person/enums/GenderEnum'
import { PersonUtils } from 'modules/person/utils/PersonUtils'
import { InputValueCallbackTP } from 'common/components/form-fields/inner/types/InputValueCallbackTP'
import { FormModel } from 'common/form-state-manager/classes/FormModel'

const OPTIONS: SelectOptionTP[] = Object.values(GenderEnum).map((gender, i) => ({
    key: `key-gender-${i}`,
    label: PersonUtils.getGenderLabel(gender),
    value: gender
}))

interface IGenderSelectorCPProps<FModelTP extends FormModel = any> extends IFormItemCommonProps<FModelTP> {
    onChange?: InputValueCallbackTP<GenderEnum>
}

/**
 * COMPONENTE
 * Seletor unitario de genero.
 */
export function GenderSelectorCP<FModelTP extends FormModel = any>(props: IGenderSelectorCPProps<FModelTP>): JSX.Element {
    return (
        <SelectCP<FModelTP>
            label={'Gênero'}
            options={OPTIONS}
            onChange={props.onChange}
            formStateManager={props.formStateManager}
            fieldName={props.fieldName}
            required={props.required}
            errorMessage={props.errorMessage}
        />
    )
}
